var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 2.5H17.5C17.8862 2.5 18.2213 2.71897 18.3879 3.03954L11.0547 7.92834C10.7188 8.15227 10.2812 8.15227 9.94531 7.92834L2.61209 3.03953C2.77868 2.71896 3.11377 2.5 3.5 2.5ZM2.5 5.3685V13.5C2.5 14.0523 2.94772 14.5 3.5 14.5H17.5C18.0523 14.5 18.5 14.0523 18.5 13.5V5.36852L12.1641 9.59244C11.1564 10.2642 9.84361 10.2642 8.83591 9.59244L2.5 5.3685ZM0.5 3.5C0.5 1.84315 1.84315 0.5 3.5 0.5H17.5C19.1569 0.5 20.5 1.84315 20.5 3.5V13.5C20.5 15.1569 19.1569 16.5 17.5 16.5H3.5C1.84315 16.5 0.5 15.1569 0.5 13.5V3.5Z",
    fill: "#B1B5C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.b6e44192d7679d704a38da67b83b07f9.svg";
export { ForwardRef as ReactComponent };